import Grid from "components/Grid";
import Text from "components/Text";
import { FC } from "react";
import { CgCardSpades } from "react-icons/cg";
import { useAppSelector } from "slice";
import { colors } from "theme/colors";
import CardTitle from "../CardTitle";
import { Bullet, CardWrapper } from "../PersonalInfo/PersonalInfo.styled";
import { MyStoryWrapper } from "./OtherInterest.styled";

export const OtherInterest: FC = () => {
    const {
        data: {
            attributes: { other_interest: otherInterests },
        },
    } = useAppSelector((state) => state.model);
    const hasSomeData = otherInterests?.interests
        ? otherInterests?.interests.length > 0 ||
          otherInterests?.my_story !== ""
        : false;

    return (
        <CardWrapper>
            <CardTitle title="Other Interest" icon={<CgCardSpades />} />
            {hasSomeData ? (
                <>
                    <Grid row={true} columnGap={1}>
                        {otherInterests?.interests &&
                            otherInterests.interests.map((interest) => (
                                <Bullet>
                                    <Text variant="body2">{interest}</Text>
                                </Bullet>
                            ))}
                    </Grid>
                    <MyStoryWrapper>
                        <Text
                            variant="body2"
                            color={colors.grey.dark}
                            fontSize="15px"
                            fontWeight="600"
                        >
                            My story
                        </Text>
                        <Text variant="body2" color="#6C6C6C" fontWeight="500">
                            {otherInterests?.my_story}
                        </Text>
                    </MyStoryWrapper>
                </>
            ) : (
                <Grid row={true} columnGap={1}>
                    <Text variant="body2">No Data Found.</Text>
                </Grid>
            )}
        </CardWrapper>
    );
};
